import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/dashboard';

export class DashboardService extends RestServiceConnection {

    getTutorsInfo = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/tutors-info',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getStudentsInfo = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/students-info',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getContractsInfo = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/contracts-info',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getNearOrdersInfo = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/near-orders-info',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getModeViewContractsInfo = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/mode-view-contracts-info',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getTotalContractsByStatus = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/total-contracts-by-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getClientsWithHigherSpending = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/clients-with-higher-spending',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getUsersContractsRanking = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/user-contracts-ranking',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

}